import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from '../constants-enumerate';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';
import {mapStatePropertiesMixin} from '@aofl/map-state-properties-mixin';

/**
 * @summary UserJobAlert
 * @extends {i18nMixin(mapStatePropertiesMixin(AoflElement))}
 */
@customElement('user-job-alert')
class UserJobAlert extends i18nMixin(mapStatePropertiesMixin(AoflElement)) {
  /**
   * Creates an instance of UserJobAlert.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
    this.translations = translations;
  }
  /**
   * @readonly
   */
  static is = 'user-job-alert';

  @property({type: String})
  ['job-id'] = 0;

  @property({type: Boolean})
  invalid = null;

  @property({})
  job = null;

  mapStateProperties() {
    const state = this.storeInstance.getState();

    this.job = state[sdoNs.USER_JOBS].$userJobsById[this['job-id']];
  }
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default UserJobAlert;
